import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'react-bootstrap';
import ReduxToastr from 'react-redux-toastr';
import LoginModalContainer from './../Containers/LoginModalContainer';
import ClipboardComponent from './ClipboardComponent';
import NavBarContainer from './../Containers/NavBarContainer';

const PageComponent = ({ children }) => {
  return (
    <div >
      <LoginModalContainer />
      <NavBarContainer />
      <br />
      <br />
      <br />
      {/* breaks needed to maintain visiblity on build page if navbar is two rows */}
      <ReduxToastr preventDuplicates />
      <ClipboardComponent />

      <Grid fluid style={{ paddingTop: '70px' }}>
        {children}
      </Grid>
    </div>
  );
};

// XXX: Add this above grid
// <AddCommentModal state={addCommentState} />
// <ShowCommentsModal state={showCommentsState} />

PageComponent.propTypes = { children: PropTypes.any.isRequired, };

export default PageComponent;


// WEBPACK FOOTER //
// src/Components/PageComponent.jsx